import styled from 'styled-components';
import { loaderTextColor } from 'utils/theme';

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px;
  color: ${loaderTextColor};

  svg {
    fill: ${loaderTextColor};
  }
`;
